import { FC } from 'react';
import { Draggable } from 'react-beautiful-dnd';
import styled, { css } from 'styled-components';

// import { ReactComponent as HyperlinkIcon } from '@/assets/icons/hyperlink.svg';
import { Td, Thumbnail } from '@/components/Table';
import Text from '@/components/Text';
import { EditorialFacebookPostResource } from '@/types/resources';
import { EditorialFacebookPostType } from '@/utils/enums';

import PostType from './PostType';

// import { HyperLink, LinkTd } from './TableRow';

interface TrProps {
  isDragging?: boolean;
}

const Tr = styled.tr<TrProps>`
  cursor: move;
  ${({ isDragging, theme }) =>
    isDragging &&
    css`
      pointer-events: none;
      display: table;
      > td {
        background: ${theme.colors.grayscale};
      }
    `};
`;

const PlaceholderTd = styled.td`
  background: ${({ theme }) => theme.colors.grayscaleExtraLight} !important;
  padding: 24px 0 !important;
  border-bottom: 1px solid ${({ theme }) => theme.colors.grayscale};
  vertical-align: middle !important;
  ${Text} {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

interface Props {
  post: Omit<EditorialFacebookPostResource, 'id'> & { id: string };
  index: number;
}

const SortableTableRow: FC<Props> = ({ post, index }) => {
  return (
    <Draggable draggableId={post.id} index={index}>
      {(provided, snapshot) => (
        <Tr
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          isDragging={snapshot.isDragging}
        >
          {post.type === EditorialFacebookPostType.PLACEHOLDER ? (
            <PlaceholderTd colSpan={4}>
              <Text $color="gray" $type="smallBold">
                Time gap placeholder
              </Text>
            </PlaceholderTd>
          ) : (
            <>
              <Td>{index + 1}</Td>
              <Td>
                <Thumbnail
                  type={
                    post.type === EditorialFacebookPostType.REEL
                      ? 'reel'
                      : 'image'
                  }
                  src={post.imageUrl}
                  alt={'Cover'}
                />
              </Td>
              <Td>{post.message}</Td>
              <Td>
                <PostType type={post.type} />
              </Td>
              {/* <LinkTd>
                <HyperLink href={post.link}>
                  <HyperlinkIcon />
                  <span>{post.link}</span>
                </HyperLink>
              </LinkTd> */}
            </>
          )}
        </Tr>
      )}
    </Draggable>
  );
};

export default SortableTableRow;
